export const shouldAddDots = (value: string, length: number = 5) => {
    return value?.length > length ? value.substring(0, length) + '...' : value;
};